import { useAppSelector } from "../../hooks/hooks";
import { RootState } from "../../store/store";

export function DefaultSystemPermission(resourceId: string, actionType: "create" | "read" | "update" | "delete") {
  const { permissions } = useAppSelector((state: RootState) => state.permissions);

  const resource = permissions?.[resourceId];
  const hasPermission = !!resource?.[actionType];

  return hasPermission;
}
